import React, { useState, useEffect, useContext } from 'react';
import { useMessageGetter, Message } from '@messageformat/react';
import api from '../api';
import { StateContext } from '../State';
import { Modal } from '@op/opds.opux-modal';
import { Button } from '@op/opds.opux';
import { fullpageloginRootId } from '../constants';
import { ModelContext } from '../ModelContext';

const AutomaticLogoutModal = (props) => {
    const state = useContext(StateContext);
    const [logoutDone, setLogoutDone] = useState(false);
    const msg = useMessageGetter('fp');
    const { model } = useContext(ModelContext);

    const onModalClose = () => {
        /* We do reload after successful logout because it zeroes model.authLevelAtPageLoad flag we use to determine if we need a logout. */
        console.debug('onModalClose called, reloading page');
        if (model.tamOp !== 'login') {
            /* Force tamOp URL parameter to be 'login' if it is something else (ie. stepup or logout). */
            /* We do this so that user doesn't get logout dialog in every page reload, which would happen if tamOp stays as 'logout'. */
            /* And also if user decides to bookmark this login page, we want bookmarked page to be tamOp=login */
            const url = new URL(window.location.href);
            url.searchParams.set('TAM_OP', 'login');
            url.searchParams.set('ERROR_CODE', '0x00000000');
            window.location.href = url.toString();
        } else {
            window.location.reload();
        }
    };

    useEffect(() => {
        /* Only logout when we are in tamOp=logout state or authenticated, and login flow has not yet started */
        if (((model.authLevelAtPageLoad > 0 && model.tamOp !== 'error') || model.tamOp === 'logout') && !model.errorCode && !state.authType) {
            api.logout()
                .then(() => {
                    setLogoutDone(true);
                })
                .catch((e) => {
                    console.debug('automatic logout failed:', e);
                    setLogoutDone(false);
                });
        }
    }, [model.authLevelAtPageLoad, model.tamOp, model.errorCode, state.authType]);

    return (
        <>
            {logoutDone && (
                <Modal
                    appElement={document.getElementById(fullpageloginRootId)}
                    footer={
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                            }}
                        >
                            <Button compact onClick={onModalClose}>
                                <Message id='fp.loggedOut.close' />
                            </Button>
                        </div>
                    }
                    isOpen={true}
                    onUpdate={() => {}}
                    title={msg('loggedOut.title')}
                    role='alert'
                >
                    <div className='opds'>
                        <p>
                            <Message id='fp.loggedOut.body' />
                        </p>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default AutomaticLogoutModal;
